import { bool, func, object } from 'prop-types';
import React from 'react';
import { Button } from 'reactstrap';

import api from '../../REST/api';
import withApiRequest from '../../REST/with-api-request';

function ExportContacts({
  onRequest,
  loading,
  searchParams,
  tableFilters,
  ...rest
}) {
  return (
    <Button
      disabled={loading}
      onClick={() =>
        onRequest({ search: { ...searchParams, ...tableFilters } })
      }
      {...rest}
    >
      Export
    </Button>
  );
}

ExportContacts.propTypes = {
  onRequest: func.isRequired,
  loading: bool.isRequired,
  searchParams: object, // eslint-disable-line react/forbid-prop-types,
  tableFilters: object, // eslint-disable-line react/forbid-prop-types,
};

ExportContacts.defaultProps = {
  searchParams: undefined,
  tableFilters: undefined,
};

export default withApiRequest({
  query: api.exportContacts,
  error: 'flash',
  successMessage: 'Email with all contacts is being prepared',
})(ExportContacts);
